import * as tslib_1 from "tslib";
import { Injector } from '@angular/core';
import { ConfigService } from './config.service';
import Amplify, { Auth, Cache } from 'aws-amplify';
import * as Sentry from "@sentry/angular";
import { DevImpersonationService } from '../_services/dev-impersonation.service';
import { DemoModeService } from '../demo-mode';
import { patchAmplifyApiForDemoMode } from '../demo-mode';
import { ViewAsScopeService, patchAmplifyApiForViewAsScope } from '../view-as-scope';
import * as i0 from "@angular/core";
import * as i1 from "./config.service";
import * as i2 from "../demo-mode/demo-mode.service";
import * as i3 from "../view-as-scope/view-as-scope.service";
var AppInitializationService = /** @class */ (function () {
    function AppInitializationService(configService, demoModeService, viewAsScopeService, injector) {
        this.configService = configService;
        this.demoModeService = demoModeService;
        this.viewAsScopeService = viewAsScopeService;
        this.injector = injector;
    }
    /**
     * Attach Cognito plus any stored impersonation token.
     * Used only on the local and staging Amplify endpoints. The prod endpoint uses
     * createProductionHeader() and never reads sessionStorage.
     */
    AppInitializationService.prototype.createCustomHeader = function (includeImpersonation) {
        var _this = this;
        if (includeImpersonation === void 0) { includeImpersonation = true; }
        return function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var headers, _a, _b, impersonationToken;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = {};
                        _b = "";
                        return [4 /*yield*/, Auth.currentSession()];
                    case 1:
                        headers = (_a.idtoken = _b + (_c.sent()).getIdToken().getJwtToken(),
                            _a);
                        if (includeImpersonation) {
                            impersonationToken = DevImpersonationService.getTokenFromStorage();
                            if (impersonationToken) {
                                headers['X-Impersonation-Token'] = impersonationToken;
                            }
                        }
                        return [2 /*return*/, headers];
                }
            });
        }); };
    };
    /**
     * Patch Cache.getItem to return View As effective attributes when enabled.
     * Production portal (host=prod) does not intercept Cache via impersonation.
     */
    AppInitializationService.prototype.patchCacheForViewAsScope = function () {
        var _this = this;
        var originalCacheGetItem = Cache.getItem.bind(Cache);
        Cache.getItem = function (key) {
            if (key === 'userAttr' && _this.viewAsScopeService.isEnabled()) {
                return _this.viewAsScopeService.getEffectiveUserAttributes();
            }
            return originalCacheGetItem(key);
        };
    };
    /**
     * Create a simple custom header function without impersonation (for production)
     */
    AppInitializationService.prototype.createProductionHeader = function () {
        var _this = this;
        return function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = {};
                        _b = "";
                        return [4 /*yield*/, Auth.currentSession()];
                    case 1: return [2 /*return*/, (_a.idtoken = _b + (_c.sent()).getIdToken().getJwtToken(),
                            _a)];
                }
            });
        }); };
    };
    AppInitializationService.prototype.initializeApp = function () {
        var config = this.configService.getAll();
        // Configure Amplify
        Amplify.configure({
            Auth: {
                region: config.region,
                userPoolId: config.userPoolId,
                userPoolWebClientId: config.clientId
            },
            API: {
                endpoints: [
                    {
                        name: 'local',
                        endpoint: config.apiEndpoints.local,
                        custom_header: this.createCustomHeader(true) // Enable impersonation for local
                    },
                    {
                        name: 'staging',
                        endpoint: config.apiEndpoints.staging,
                        custom_header: this.createCustomHeader(true) // Enable impersonation for staging
                    },
                    {
                        name: 'prod',
                        endpoint: config.apiEndpoints.prod,
                        custom_header: this.createProductionHeader() // No impersonation in production
                    },
                    {
                        name: 'banner_s3_staging',
                        endpoint: config.apiEndpoints.banner_s3_staging
                    },
                    {
                        name: 'banner_s3',
                        endpoint: config.apiEndpoints.banner_s3
                    }
                ]
            }
        });
        // Patch Amplify API to inject View As scope params when enabled (BEFORE demo mode so we modify requests first)
        patchAmplifyApiForViewAsScope(this.viewAsScopeService);
        // Patch Amplify API to anonymize responses when demo mode is enabled (super admins only)
        patchAmplifyApiForDemoMode(this.demoModeService, this.viewAsScopeService);
        // Patch Cache.getItem to return effective user attributes when View As is enabled.
        this.patchCacheForViewAsScope();
        // Construct impersonation after config + the View As Cache patch. PortalViewGuard
        // reads Cache before BaseComponent is created, so staging production builds must
        // enable this here or the retail preview looks like super-admin on first navigation.
        this.injector.get(DevImpersonationService).enableForRuntime(config.host);
        // Initialize Sentry only in production
        if (config.host === 'prod') {
            Sentry.init({
                dsn: config.sentryDsn,
                integrations: [],
            });
        }
    };
    AppInitializationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AppInitializationService_Factory() { return new AppInitializationService(i0.ɵɵinject(i1.ConfigService), i0.ɵɵinject(i2.DemoModeService), i0.ɵɵinject(i3.ViewAsScopeService), i0.ɵɵinject(i0.INJECTOR)); }, token: AppInitializationService, providedIn: "root" });
    return AppInitializationService;
}());
export { AppInitializationService };
